import React from 'react';
import { FilledIconContainer, IconContainer } from 'theming/tokens/components/icon';
const ExternalLinkIcon = props => {
  if (props.variant === 'filled') {
    return /*#__PURE__*/React.createElement(FilledIconContainer, {
      fill: props.fill,
      size: props.size
    }, /*#__PURE__*/React.createElement("path", {
      d: "M192,136v72a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64h72a8,8,0,0,1,0,16H48V208H176V136a8,8,0,0,1,16,0Zm32-96a8,8,0,0,0-8-8H152a8,8,0,0,0-5.66,13.66L172.69,72l-42.35,42.34a8,8,0,0,0,11.32,11.32L184,83.31l26.34,26.35A8,8,0,0,0,224,104Z"
    }));
  }
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("polyline", {
    points: "216 104 215.99 40.01 152 40",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "136",
    y1: "120",
    x2: "216",
    y2: "40",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,136v72a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h72",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }));
};
export { ExternalLinkIcon };